import {ApiFindOptions, useApiFind} from "../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornAsset} from "../../../../application/business/StubbornAsset";

export const useRosterFind = (options: ApiFindOptions = {}) => useApiFind<StubbornAsset>(PATH, options);
